var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VueSelect',{staticClass:"v-select-light",attrs:{"options":_vm.options,"multiple":"","placeholder":"Приоритет"},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }